import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';

import {
  ExpansionPanel as IndigoExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelProps,
  ExpansionPanelSummary,
  palettes,
  SmallTitle
} from '@indigo-ag/component-module';

export interface EnhancedExpansionPanelProps extends Omit<ExpansionPanelProps, 'title'> {
  title: React.ReactNode | string;
}

export const EnhancedExpansionPanel: React.FunctionComponent<EnhancedExpansionPanelProps> = ({
  title,
  children,
  ...rest
}) => {
  return (
    <IndigoExpansionPanel {...rest}>
      <ExpansionPanelSummary
        expandIcon={
          <FontAwesomeIcon icon={faChevronDown} style={{ color: palettes.coastal.core.mediumBlue, fontSize: 14 }} />
        }
      >
        {typeof title === 'string' ? <SmallTitle className="text-transform-capitalize">{title}</SmallTitle> : title}
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>{children}</ExpansionPanelDetails>
    </IndigoExpansionPanel>
  );
};
